import counter2 from "../../../assets/images/portfolio/counter2.webp";
import dadjoke from "../../../assets/images/portfolio/dadjoke.webp";
import darkmode from "../../../assets/images/portfolio/darkmode.webp";
import numbers from "../../../assets/images/portfolio/numbers.webp";
import gallery from "../../../assets/images/portfolio/gallery.webp";
import cocktails from "../../../assets/images/portfolio/cocktails.webp";
import slider2 from "../../../assets/images/portfolio/slider2.webp";
import products from "../../../assets/images/portfolio/products.webp";
import wikipedia from "../../../assets/images/portfolio/wikipedia.webp";
import filters from "../../../assets/images/portfolio/filters.webp";
import pagination from "../../../assets/images/portfolio/pagination.webp";
import randomuser from "../../../assets/images/portfolio/randomuser.webp";
import stripesubmenus from "../../../assets/images/portfolio/stripesubmenus.webp";
import comfystore from "../../../assets/images/portfolio/comfystore.webp";
import battleship from "../../../assets/images/portfolio/battleship.webp";

const jquery_projects_data = [
  {
    img: battleship,
    isResponsive: false,
    title: "Battleship App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: true,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/battleship-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://battleshipapp.surge.sh/",
    },
  },
  {
    img: comfystore,
    isResponsive: false,
    title: "Comfy Store App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/comfy-store-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://comfystoreapp.surge.sh/",
    },
  },
  {
    img: stripesubmenus,
    isResponsive: true,
    title: "Stripe Submenus App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/stripe-submenus-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://stripesubmenusapp.surge.sh/",
    },
  },
  {
    img: randomuser,
    isResponsive: false,
    title: "Stripe Submenus App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/random-user-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://randomuserapp.surge.sh/",
    },
  },
  {
    img: pagination,
    isResponsive: false,
    title: "Pagination App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/pagination-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://paginationapp.surge.sh/",
    },
  },
  {
    img: filters,
    isResponsive: false,
    title: "Filters App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/filters-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://filtersapp.surge.sh/",
    },
  },
  {
    img: wikipedia,
    isResponsive: false,
    title: "Wikipedia App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/wikipedia-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://wikipediaapp.surge.sh/",
    },
  },
  {
    img: products,
    isResponsive: false,
    title: "Products App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/products-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://products1app.surge.sh/",
    },
  },
  {
    img: slider2,
    isResponsive: false,
    title: "Slider App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/slider2-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://slider2app.surge.sh/",
    },
  },
  {
    img: cocktails,
    isResponsive: false,
    title: "Cocktails App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/cocktails-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://cocktailsapp.surge.sh/",
    },
  },
  {
    img: gallery,
    isResponsive: false,
    title: "Gallery App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/gallery-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://gallery1app.surge.sh/",
    },
  },
  {
    img: numbers,
    isResponsive: false,
    title: "Numbers App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/numbers-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://numbersapp.surge.sh/",
    },
  },
  {
    img: darkmode,
    isResponsive: false,
    title: "Dark Mode App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/dark-mode-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://darkmodeapp.surge.sh/",
    },
  },
  {
    img: dadjoke,
    isResponsive: false,
    title: "Dad Jokes App",
    html: true,
    css: true,
    bootstrap: true,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/dad-jokes-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://dadjokesapp.surge.sh/",
    },
  },
  {
    img: counter2,
    isResponsive: false,
    title: "Simple Counter App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: true,
    jqueryyui: false,
    tailwindd: false,
    react: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/counter-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://simplecounter2app.surge.sh/",
    },
  },
];

export default jquery_projects_data;
